export const windowInnerWidth = () => window.innerWidth;

export const bodyClientWidth = () => document.body.clientWidth;
